import { WithTrackEventProps } from "@newsela/snitch";

export type TGeniusPanelOptionType =
  | "internal-panel-link"
  | "download"
  | "external-link";

export type TGeniusPanelName =
  | "assignment"
  | "diy_activity_guide"
  | "vocabulary"
  | "discussion_questions"
  | "reading_materials"
  | "practice_word_problems"
  | "practice_number_problems"
  | "diy_activity_guide"
  | "teacher_resources";
export interface IGeniusButtonEventProperties
  extends Pick<WithTrackEventProps, "objectType" | "actionName"> {
  streamProperties: {
    content_type: string;
    description: string;
    content_id?: string;
  };
}

export const RESOURCE_NAMES = {
  lesson_plan: "Lesson Plan",
  teacher_guide: "Teacher Information",
  reading_materials: "Reading Material",
  diy_activity_guide: "DIY Activity Guide",
  practice_word_problems: "Practice Word Problems",
  practice_number_problems: "Practice Number Problems",
};
